/* Lost Collective — /collections archive index.
   Filter (data-cat), sort (az / newest / oldest), A-Z rail jump,
   mobile rail sheet, count display.

   Sprint 03 (2026-04-30): cells are no longer server-rendered. The
   section emits a JSON manifest of all series; this script renders
   them into letter group skeletons on DOMContentLoaded. Cuts initial
   doc weight by ~85 KB (76 cells × ~1.3 KB → 0). Filter / sort /
   A-Z rail all operate on the rendered DOM exactly as before, so the
   wiring below is unchanged from the pre-sprint-03 file aside from
   the new render pass.

   Without JS the .lc-archive--no-js class hides controls; the page
   still shows themes (server-rendered) and an empty series grid with
   the JSON manifest as a fallback for crawlers / curl. Sitemap
   guarantees discovery of every series URL regardless. */
(function () {
  'use strict';

  var root = document.querySelector('[data-lc-archive]');
  if (!root) return;

  var pillsEl = root.querySelector('[data-lc-pills]');
  var sortEl = root.querySelector('[data-lc-sort]');
  var seriesGrid = root.querySelector('[data-lc-series-grid]');
  var letterGroups = root.querySelectorAll('[data-lc-letter-group]');
  var countShownEl = root.querySelector('[data-lc-count-shown]');
  var countTotalEl = root.querySelector('[data-lc-count-total]');
  var seriesCountEl = root.querySelector('[data-lc-series-count]');
  var rail = root.querySelector('[data-lc-rail]');
  var sheetToggle = root.querySelector('[data-lc-rail-toggle]');
  var sheet = root.querySelector('[data-lc-rail-sheet]');
  var sheetClose = root.querySelector('[data-lc-rail-sheet-close]');

  /* ----- Read manifest + render cells into letter groups -----
     Manifest is a JSON array emitted in the section. Group entries
     by letter, build a DocumentFragment per letter, append in one
     pass per group to avoid per-cell layout thrash. */
  var manifest = [];
  var manifestEl = document.getElementById('lc-archive-manifest');
  if (manifestEl) {
    try {
      manifest = JSON.parse(manifestEl.textContent);
    } catch (_e) {
      manifest = [];
    }
  }

  function appendWidth(url, w) {
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
  }

  function buildCell(m) {
    var a = document.createElement('a');
    /* Orientation classification mirrors the lc-orientation snippet:
       aspect_ratio >= 1.2 → landscape, <= 0.85 → portrait, else
       square. Drives the meta-row image-bounded alignment in
       sections/main-list-collections.liquid. Default to landscape
       when image dimensions are missing — matches the snippet's
       1.5 fallback. */
    var coverOrient = 'landscape';
    if (m.img && m.img.width && m.img.height) {
      var ar = m.img.width / m.img.height;
      if (ar >= 1.2) coverOrient = 'landscape';
      else if (ar <= 0.85) coverOrient = 'portrait';
      else coverOrient = 'square';
    }
    a.className = 'lc-archive-cell lc-archive-cell--series lc-archive-cell--' + coverOrient;
    a.href = m.url;
    a.setAttribute('data-cat', m.category || 'theme');
    a.setAttribute('data-letter', m.letter);
    a.setAttribute('data-year', m.year || 0);
    a.setAttribute('data-title', m.title);

    var cellWrap = document.createElement('div');
    cellWrap.className = 'lc-cell lc-cell--square lc-cell--contain';

    if (m.img && m.img.url) {
      var img = document.createElement('img');
      var base = m.img.url;
      img.src = appendWidth(base, 1200);
      img.srcset =
        appendWidth(base, 480) + ' 480w, ' +
        appendWidth(base, 800) + ' 800w, ' +
        appendWidth(base, 1200) + ' 1200w';
      img.sizes = '(min-width: 1200px) 25vw, (min-width: 990px) 33vw, (min-width: 480px) 50vw, 100vw';
      if (m.img.width) img.width = m.img.width;
      if (m.img.height) img.height = m.img.height;
      img.alt = m.img.alt || m.title;
      img.loading = 'lazy';
      img.decoding = 'async';
      img.fetchPriority = 'auto';
      cellWrap.appendChild(img);
    }
    a.appendChild(cellWrap);

    var info = document.createElement('div');
    info.className = 'lc-archive-cell__info';

    var hasLoc = m.location && m.location.length > 0;
    var hasYear = m.year && m.year > 0;
    if (hasLoc || hasYear) {
      var meta = document.createElement('div');
      meta.className = 'lc-archive-cell__meta';
      if (hasLoc) {
        var locSpan = document.createElement('span');
        locSpan.textContent = m.location;
        meta.appendChild(locSpan);
        if (hasYear) {
          var sep = document.createElement('span');
          sep.className = 'lc-archive-cell__sep';
          sep.textContent = '·';
          meta.appendChild(sep);
          var yearSpan = document.createElement('span');
          yearSpan.textContent = m.year;
          meta.appendChild(yearSpan);
        }
      } else {
        var yearOnly = document.createElement('span');
        yearOnly.textContent = m.year;
        meta.appendChild(yearOnly);
      }
      info.appendChild(meta);
    }

    var title = document.createElement('div');
    title.className = 'lc-archive-cell__title';
    title.textContent = m.title;
    info.appendChild(title);

    var count = document.createElement('div');
    count.className = 'lc-archive-cell__count';
    var countNum = document.createElement('b');
    countNum.textContent = m.count;
    count.appendChild(countNum);
    count.appendChild(document.createTextNode(
      ' ' + (m.count === 1 ? 'print in series' : 'prints in series')
    ));
    info.appendChild(count);

    a.appendChild(info);
    return a;
  }

  function renderCells() {
    if (!manifest.length) return;
    var fragments = {};
    manifest.forEach(function (m) {
      var L = m.letter;
      if (!fragments[L]) fragments[L] = document.createDocumentFragment();
      fragments[L].appendChild(buildCell(m));
    });
    letterGroups.forEach(function (g) {
      var grid = g.querySelector('.lc-archive__grid');
      var L = g.getAttribute('data-letter');
      if (grid && fragments[L]) grid.appendChild(fragments[L]);
    });
    if (seriesGrid) seriesGrid.removeAttribute('aria-busy');
  }

  /* Render BEFORE flipping the no-js class so the no-js empty state
     never flashes. Then mark the archive as JS-enhanced. */
  renderCells();
  root.classList.remove('lc-archive--no-js');
  root.classList.add('lc-archive--js');

  /* ----- Build the desktop A-Z rail and the mobile sheet grid -----
     Each letter is an in-page jump link to its letter group's element id
     (`#lc-L-<letter>`). The href makes the link discoverable to
     Lighthouse's `crawlable-anchors` audit and lets right-click + keyboard
     copy-link work the same as any other anchor. The bindJump handler
     still preventDefaults to apply smooth scrolling, so behaviour is
     unchanged from the user's POV. Letters with no series have the
     anchor present but un-clickable (the click handler is a no-op when
     the target group is empty), keeping the alphabet visually complete. */
  function buildRail() {
    var letters = [];
    letterGroups.forEach(function (g) {
      letters.push(g.getAttribute('data-letter'));
    });
    var letterSet = new Set(letters);
    var alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ#';
    var html = alphabet.split('').map(function (L) {
      var has = letterSet.has(L);
      /* href points to the letter-group anchor regardless of whether the
         group has visible cells. Empty groups exist in the DOM but have
         the .is-empty class hiding them — clicking still goes nowhere
         visually because bindJump no-ops on empty groups, but the link
         is crawlable for Lighthouse and JS-off readers can still see the
         alphabet structure as semantic anchors. */
      return '<a class="no-hover ' + (has ? 'has' : '') +
        '" href="#lc-L-' + L + '"' +
        ' data-jump="' + L + '" aria-label="Jump to ' + L + '">' + L + '</a>';
    }).join('');
    if (rail) rail.innerHTML = html;
    var sheetGrid = root.querySelector('[data-lc-rail-sheet-grid]');
    if (sheetGrid) sheetGrid.innerHTML = html;
    bindJump();
  }

  function bindJump() {
    var jumpEls = root.querySelectorAll('[data-jump]');
    jumpEls.forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        var L = a.getAttribute('data-jump');
        var tgt = root.querySelector('[data-lc-letter-group][data-letter="' + L + '"]');
        if (tgt && !tgt.classList.contains('is-empty')) {
          var prefersReduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          tgt.scrollIntoView({ behavior: prefersReduce ? 'auto' : 'smooth', block: 'start' });
          if (sheet) sheet.classList.remove('is-open');
        }
      });
    });
  }

  /* ----- Filter + sort ----- */
  function applyFilter(cat) {
    var totalShown = 0;
    var totalAll = 0;
    letterGroups.forEach(function (g) {
      var cells = g.querySelectorAll('.lc-archive-cell');
      var visibleInGroup = 0;
      cells.forEach(function (cell) {
        totalAll++;
        var match = cat === 'all' || cell.getAttribute('data-cat') === cat;
        cell.classList.toggle('is-hidden', !match);
        if (match) {
          visibleInGroup++;
          totalShown++;
        }
      });
      g.classList.toggle('is-empty', visibleInGroup === 0);
      var n = g.querySelector('[data-lc-letter-n]');
      if (n) n.textContent = visibleInGroup;
    });
    if (countShownEl) countShownEl.textContent = totalShown;
    if (countTotalEl) countTotalEl.textContent = totalAll;
    if (seriesCountEl) seriesCountEl.textContent = totalShown;
    refreshRail();
  }

  function refreshRail() {
    var hasMap = {};
    letterGroups.forEach(function (g) {
      var L = g.getAttribute('data-letter');
      hasMap[L] = !g.classList.contains('is-empty');
    });
    var aEls = root.querySelectorAll('[data-jump]');
    aEls.forEach(function (a) {
      a.classList.toggle('has', !!hasMap[a.getAttribute('data-jump')]);
    });
  }

  function applySort(mode) {
    if (!seriesGrid) return;
    /* Sort the ENTIRE flat list of cells, then re-bucket into letter
       groups. For az we restore the natural DOM order (cells were
       rendered alphabetised by the manifest's source sort). For
       newest/oldest we sort by data-year. */
    if (mode === 'az') {
      letterGroups.forEach(function (g) {
        var grid = g.querySelector('.lc-archive__grid');
        if (!grid) return;
        var cells = Array.prototype.slice.call(grid.querySelectorAll('.lc-archive-cell'));
        cells.sort(function (a, b) {
          return a.getAttribute('data-title').localeCompare(b.getAttribute('data-title'));
        });
        cells.forEach(function (c) { grid.appendChild(c); });
      });
      return;
    }
    /* newest / oldest — flatten, sort by year, group back by letter. */
    var allCells = Array.prototype.slice.call(seriesGrid.querySelectorAll('.lc-archive-cell'));
    allCells.sort(function (a, b) {
      var ya = parseInt(a.getAttribute('data-year') || '0', 10);
      var yb = parseInt(b.getAttribute('data-year') || '0', 10);
      return mode === 'newest' ? yb - ya : ya - yb;
    });
    /* Distribute into existing letter groups (kept in DOM order)
       so the A-Z rail still works as a "where am I" affordance. */
    letterGroups.forEach(function (g) {
      var grid = g.querySelector('.lc-archive__grid');
      if (grid) grid.innerHTML = '';
    });
    allCells.forEach(function (cell) {
      var L = cell.getAttribute('data-letter');
      var tgt = root.querySelector('[data-lc-letter-group][data-letter="' + L + '"] .lc-archive__grid');
      if (tgt) tgt.appendChild(cell);
    });
  }

  /* ----- Wiring ----- */
  if (pillsEl) {
    pillsEl.addEventListener('click', function (e) {
      var pill = e.target.closest('.lc-archive__pill');
      if (!pill) return;
      pillsEl.querySelectorAll('.lc-archive__pill').forEach(function (p) {
        p.classList.remove('is-on');
      });
      pill.classList.add('is-on');
      applyFilter(pill.getAttribute('data-cat') || 'all');
    });
  }

  if (sortEl) {
    sortEl.addEventListener('change', function () {
      applySort(sortEl.value);
    });
  }

  if (sheetToggle && sheet) {
    sheetToggle.addEventListener('click', function () {
      sheet.classList.add('is-open');
    });
  }
  if (sheetClose && sheet) {
    sheetClose.addEventListener('click', function () {
      sheet.classList.remove('is-open');
    });
  }

  /* ----- Filter bar sticky animate-in / animate-out ----------
     position:sticky has no native event, so we watch a zero-height
     sentinel placed immediately before the bar. When the sentinel
     exits the adjusted root (top margin = header height), the bar
     is in sticky position → add is-stuck. When it re-enters, begin
     the exit animation before clearing the class. */
  var filterBar = root.querySelector('.lc-archive__filter');
  if (filterBar && 'IntersectionObserver' in window) {
    var sentinel = document.createElement('div');
    sentinel.setAttribute('aria-hidden', 'true');
    sentinel.style.cssText = 'height:1px;margin-bottom:-1px;pointer-events:none;visibility:hidden;';
    filterBar.parentNode.insertBefore(sentinel, filterBar);

    var headerH = parseInt(
      getComputedStyle(document.documentElement).getPropertyValue('--lc-header-h') || '85',
      10
    );

    var exitTimer = null;

    var stickyObs = new IntersectionObserver(function (entries) {
      var entry = entries[0];
      clearTimeout(exitTimer);
      if (!entry.isIntersecting) {
        filterBar.classList.remove('is-stuck-exit');
        filterBar.classList.add('is-stuck');
      } else {
        filterBar.classList.remove('is-stuck');
        filterBar.classList.add('is-stuck-exit');
        exitTimer = setTimeout(function () {
          filterBar.classList.remove('is-stuck-exit');
        }, 170);
      }
    }, {
      rootMargin: '-' + (headerH + 1) + 'px 0px 0px 0px',
      threshold: 0
    });

    stickyObs.observe(sentinel);
  }

  /* buildRail must run before the dock setup so rail <a> tags exist */
  buildRail();
  applyFilter('all');

  /* ----- Pin rail below actual rendered header ----------------------
     CSS uses --lc-header-h as a fallback, but the Shopify preview bar
     and responsive header height changes can make the computed value
     wrong. Reading getBoundingClientRect() at runtime is exact. */
  var headerEl = document.getElementById('lc-header');
  if (headerEl && rail) {
    function syncRailTop() {
      var bottom = Math.round(headerEl.getBoundingClientRect().bottom);
      rail.style.top = bottom + 'px';
      rail.style.height = (window.innerHeight - bottom) + 'px';
    }
    syncRailTop();
    window.addEventListener('resize', syncRailTop, { passive: true });
    if ('ResizeObserver' in window) {
      new ResizeObserver(syncRailTop).observe(headerEl);
    }
  }

  /* ----- A-Z rail dock magnification (hover: hover devices only) ----
     Smoothstep bell curve centred on the cursor. Peak letter turns
     ochre; neighbours darken to ink; distant letters keep graphite.
     Letters expand leftward past the rail border (overflow: visible,
     position: fixed — no layout shift). Mouseleave triggers .is-leaving
     for a smooth 220ms ease-back transition. */
  if (rail && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    var railLinks  = Array.prototype.slice.call(rail.querySelectorAll('a'));
    var DOCK_MAX   = 2.4;  /* peak letter fixed scale */
    var DOCK_R     = 60;   /* tighter radius → steeper falloff on neighbours */
    var leaveTimer = null;

    rail.addEventListener('mousemove', function (e) {
      clearTimeout(leaveTimer);
      rail.classList.remove('is-leaving');
      var my = e.clientY;

      /* Cubic curve (steeper than smoothstep) so neighbours drop off fast */
      var eases = railLinks.map(function (a) {
        var box  = a.getBoundingClientRect();
        var cy   = box.top + box.height / 2;
        var dist = Math.abs(my - cy);
        var t    = Math.max(0, 1 - dist / DOCK_R);
        return t * t * t;
      });

      var maxEase = Math.max.apply(null, eases);
      var isPeak  = maxEase > 0.05;

      railLinks.forEach(function (a, i) {
        var ease = eases[i];
        var peak = isPeak && ease === maxEase;
        /* Peak: locked at DOCK_MAX scale + bold + ochre.
           Neighbours: proportional scale, ink, normal weight.
           Distant: baseline. */
        a.style.transform = 'scale(' + (peak ? DOCK_MAX : 1 + (DOCK_MAX - 1) * ease) + ')';
        a.style.color     = peak ? 'var(--lc-ochre)' : ease > 0.05 ? 'var(--lc-ink)' : '';
      });
    });

    rail.addEventListener('mouseleave', function () {
      rail.classList.add('is-leaving');
      railLinks.forEach(function (a) {
        a.style.transform = '';
        a.style.color     = '';
      });
      leaveTimer = setTimeout(function () {
        rail.classList.remove('is-leaving');
      }, 240);
    });
  }
})();
